import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'card',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
    id = input.required<string>();
    header = input<string>('');
    icon = input<string>('');
    iconColor = input<string>('var(--card-header-color)');
    customHeader = input<boolean>(false);
}
